const styles = {
  container: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  title: {
    marginBottom: '.5em',
  },
  description: {
    marginBottom: '.5em',
  },
  buttonPlay: {
    marginRight: '.5em',
  },
  progress: {
    flex: '1',
    display: 'flex',
    flexDirection: 'row',
  },
  progressTime: {
    width: '50%',
    textAlign: 'start',
    fontSize: '.8em',
  },
  progressEnd: {
    textAlign: 'end',
  },
  divider: {
    marginTop: '1em',
    marginBottom: '1em',
  },
};

export default styles;
